module.exports = __webpack_public_path__ + "static/rexall-logo-41b30b392c92fbb852a7118472a639ac.jpg";